// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3tc9A","inputWrap":"styles_inputWrap__3F3et","input":"styles_input__2mXlJ"};